import React from 'react';
import { ArrowDown } from 'lucide-react';
interface WorkflowDiagramProps {
  title: string;
  steps: string[];
}
export function WorkflowDiagram({
  title,
  steps
}: WorkflowDiagramProps) {
  return <div className="my-8 rounded-xl border bg-card p-6 shadow-sm" data-id="element-259">
      <h4 className="mb-6 text-lg font-semibold text-foreground" data-id="element-260">{title}</h4>
      <div className="relative space-y-4" data-id="element-261">
        {steps.map((step, index) => <div key={index} className="relative z-10" data-id="element-262">
            <div className="flex items-center gap-4" data-id="element-263">
              <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-primary text-sm font-bold text-primary-foreground shadow-sm" data-id="element-264">
                {index + 1}
              </div>
              <div className="flex-1 rounded-lg border bg-background p-4 shadow-sm" data-id="element-265">
                <p className="text-sm font-medium text-foreground" data-id="element-266">{step}</p>
              </div>
            </div>
            {index < steps.length - 1 && <div className="absolute left-4 top-8 -z-10 h-full w-px bg-border flex items-center justify-center" data-id="element-267">
                <ArrowDown className="h-4 w-4 text-muted-foreground bg-card translate-y-4" data-id="element-268" />
              </div>}
          </div>)}
      </div>
    </div>;
}